import "./footer.css";


const Footer = () => {
  return (
    <>
      <div id="footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="branding-footer">
                <a href="https://www.leivahnos.com.ar">
                  <img src="https://www.leivahnos.com.ar/wp-content/uploads/2023/11/leiva_logo_footer-1-e1720734786808.png" alt="Leiva Hermanos Branding" />
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="dataweb-image-container">
                <a href="http://qr.afip.gob.ar/?qr=Z2SjT5sdZ7xIkpskUVuqrw,,">
                  <img className="data-fiscal" src="https://www.leivahnos.com.ar/wp-content/uploads/2021/03/DATAWEB.jpg" alt="Data Fiscal" />
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="copyright-container">
                <h2 id="copyrights" className="mb-0">
                  Copyright
                  <a href="https://www.leivahnos.com.ar"><b> 2024 LEIVA HNOS </b></a>
                  Todos los derechos reservados. Prohibida la duplicación, distribución o almacenamiento en cualquier medio.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default Footer;

